import { render, staticRenderFns } from "./KinderverwaltungScanAPI.vue?vue&type=template&id=0cfb1453"
import script from "./KinderverwaltungScanAPI.vue?vue&type=script&lang=js"
export * from "./KinderverwaltungScanAPI.vue?vue&type=script&lang=js"
import style0 from "./KinderverwaltungScanAPI.vue?vue&type=style&index=0&id=0cfb1453&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports